import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { UrlParams } from "../../models/url-params";
import { from, Observable, of, throwError } from "rxjs";
import { ApplicationApiProvider } from "../application-api/application-api";
import { DemoProvider } from "../demo/demo";
import { Keychain } from "@ionic-native/keychain";
import { Platform } from "ionic-angular";
import { urlBuilder } from "../../app/urlBuilder";
declare var cordova: any;
import "rxjs/add/operator/mergeMap";
import { ToastController } from "ionic-angular";
import "rxjs/add/operator/retry"; // don't forget the imports
import "rxjs/add/operator/catch";
import { map, tap } from "rxjs/operators";

@Injectable()
export class StarmsClientProvider {
  private apiVersion: "v3" | "v4" | null = "v4";
  private starmsBase = "https://sta-rms.siemens-energy.com/";
  private apiBase = "https://sta-rms.siemens-energy.com/api/";
  private STARMS_TEST = "https://test.sta-rms.siemens-energy.cloud/api/";

  constructor(
    private http: HttpClient,
    private appApi: ApplicationApiProvider,
    private demoMode: DemoProvider,
    private keychain: Keychain,
    private platform: Platform,
    public toastCtrl: ToastController
  ) {}

  get(url: Array<string | number>, params?: UrlParams): Observable<any> {
    return from(this.getToken()).mergeMap((token) => {
      return this.angularGet(token, url, params);
    });
  }

  getReport(reportId: number) {
    return from(this.getToken()).mergeMap((token) => {
      const url = this.apiBase + this.apiVersion + `/reports/${reportId}`;
      return this.http.get(url, {
        headers: {
          Authorization: "Bearer " + token,
        },
        responseType: "blob",
      });
    });
  }

  post(url: any, params: any, bodyParams?: any): Observable<any> {
    return from(this.getToken()).mergeMap((token) => {
      return this.angularPost(token, url, params, bodyParams);
    });
  }

  put(url: Array<string | number>, bodyParams: any): Observable<any> {
    return from(this.getToken()).mergeMap((token) => {
      return this.angularPut(token, url, null, bodyParams);
    });
  }

  onDeviceReady() {}

  setEnvironment(env: string): void {
    document.addEventListener("deviceready", this.onDeviceReady, false);
    if (localStorage.getItem("test_api")) {
      this.apiBase = this.STARMS_TEST;
      this.apiVersion = "v4";
    } else {
      switch (env) {
        case "prod": {
          this.demoMode.demoMode = false;
          this.apiBase = "https://sta-rms.siemens-energy.com/api/";
          // this.apiBase = 'https://sta-rms-test01.ww007.siemens.net/api/';
          this.apiVersion = "v4";
          break;
        }
        case "demo-data": {
          this.apiVersion = null;
          this.demoMode.demoMode = true;

          this.apiBase = `https://sta-rms.siemens-energy.com/myhealth/assets/demo-data`;
          break;
        }
        default: {
          this.demoMode.demoMode = false;
          this.apiBase = "https://sta-rms.siemens-energy.com/api/";
          this.apiVersion = "v4";
        }
      }
    }
  }

  private angularGet(
    token: string,
    url: Array<string | number>,
    params?: UrlParams
  ): Observable<any> {
    const basicUrl = urlBuilder(url, params);
    if (basicUrl.includes("proxy")) {
      return this.http.get(basicUrl, {
        headers: {
          Authorization: "Bearer " + token,
        },
        // withCredentials: true,
      });
    }
    const urlFormat =
      this.apiBase +
      (this.apiVersion === null ? "" : this.apiVersion) +
      "/" +
      urlBuilder(url, params);
    return this.http
      .get(urlFormat, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .pipe(
        tap((data) => {
          if (data == [] || !data) {
            this.noDataToast();
          }
        })
      )
      .catch((err: HttpErrorResponse) => {
        this.presentErrorToast(err);

        return of([]);
      });
  }

  private angularPost(
    token,
    url: Array<string | number>,
    params: UrlParams,
    bodyParams?: any
  ): Observable<any> {
    const basicUrl = urlBuilder(url, params);
    if (basicUrl.includes("proxy")) {
      return this.http
        .post(basicUrl, bodyParams, {
          headers: {
            Authorization: "Bearer " + token,
          },
        })
        .catch((err: HttpErrorResponse) => {
          this.presentErrorToast(err);

          return of([]);
        });
    }

    const urlFormat =
      this.apiBase +
      (this.apiVersion === null ? "" : this.apiVersion) +
      "/" +
      urlBuilder(url, params);

    return this.http
      .post(urlFormat, bodyParams, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .catch((err: HttpErrorResponse) => {
        this.presentErrorToast(err);
        return of([]);
      });
  }

  private angularPut(
    token,
    url: Array<string | number>,
    params: UrlParams,
    bodyParams: any
  ): Observable<any> {
    const urlFormat =
      this.apiBase +
      (this.apiVersion === null ? "" : this.apiVersion) +
      "/" +
      urlBuilder(url, params);

    return this.http
      .put(urlFormat, bodyParams, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .catch((err: HttpErrorResponse) => {
        this.presentErrorToast(err);
        return of([]);
      });
  }

  public async getToken(): Promise<string> {
    if (this.platform.is("ios") && this.appApi.isNative()) {
      try {
        return await this.keychain.get("token", "");
      } catch (e) {
        return await null;
      }
    } else {
      try {
        return await localStorage.getItem("token");
      } catch (e) {
        console.log(e);
        return null;
      }
    }
  }

  presentErrorToast(err: HttpErrorResponse) {
    let message = "";
    if (err.status == 404) {
      message = "Some data is missing.";
    } else if (err.status == 500) {
      message = "Internal server error.";
    } else {
      message = "There is a problem with the connection.";
    }
    const toast = this.toastCtrl.create({
      message: message,
      duration: 2000,
    });
    toast.present();
  }
  noDataToast() {
    const toast = this.toastCtrl.create({
      message: "Some data is missing.",
      duration: 2000,
    });
    toast.present();
  }
  public getInformingMessages(): Observable<any> {
    return this.http.get("./assets/demo-data/inform.json");
    // return this.http.get(this.starmsBase + '/myhealth/assets/demo-data/inform.json');
  }
}



// WEBPACK FOOTER //
// ./src/providers/starms-client/starms-client.ts